const MONTHS = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const norm = (t) => (t || "").toLowerCase().replace(/[^a-z0-9]/g, "");
const doiOf = (it) => (it.url || "").toLowerCase().split("doi.org/")[1] || null;
const sameWork = (w, it) => (w.doi && w.doi === doiOf(it)) || (norm(it.title).startsWith(norm(w.title)) && norm(w.title).length > 20);
const sortKey = (w) => `${w.year || "0000"}${w.month || "00"}`;

const fromOrcid = (w) => {
  const when = [MONTHS[Number(w.month) || 0], w.year].filter(Boolean).join(" ");
  const isBook = w.type === "book";
  const parts = ["Author: Prof. Dr. Vladimir Bunic", w.journal,
    w.volume && `Vol. ${w.volume}${w.issue ? `, No. ${w.issue}` : ""} (${w.year})`, w.pages && `pp. ${w.pages}`, when, w.doi && `DOI: ${w.doi}`];
  return {
    tag: isBook ? "Book" : "Peer-Reviewed Paper",
    year: w.year || "",
    title: w.title,
    summary: w.abstract || `${isBook ? "Book" : "Journal article"} by Prof. Dr. Vladimir Bunic${w.journal ? `, published in ${w.journal}` : ""}.`,
    meta: parts.filter(Boolean).join(" · "),
    url: w.url || "https://orcid.org/0009-0006-6209-629X",
    cta: isBook ? "View publication" : "View in journal",
    orcid: true,
  };
};

// ORCID is the source of truth for which works appear; curated static entries keep their richer summaries.
export const mergeOrcid = (works, research, books) => {
  if (!works?.length) return { research, books };
  const pick = (types, curated) => {
    const ws = works.filter((w) => types.includes(w.type)).sort((a, b) => sortKey(b).localeCompare(sortKey(a)));
    const out = ws.map((w) => curated.find((it) => sameWork(w, it)) || fromOrcid(w));
    return out;
  };
  const research2 = pick(["journal-article", "conference-paper", "preprint", "report", "working-paper"], research);
  const books2 = pick(["book", "book-chapter"], books);
  const extraBooks = books.filter((b) => !books2.includes(b));
  return { research: research2, books: [...books2, ...extraBooks] };
};
